// extracted by mini-css-extract-plugin
module.exports = {"close":"_32bbee5fda--close--g3sc2"};